<template>
  <!-- All data are test and static for now, will need to change them for sure -->
  <div :class="[overallDivClass, overallDivClassCustom]">
    <div :class="[titleClass, titleCSSPropsStyle]">
      {{ fundType }}
    </div>
    <div
      class="px-[16px] md:px-[20px] lg:px-[24px] py-[12px] md:py-[14px] lg:py-[16px] text-[1rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.25rem] md:leading-[2rem] lg:leading-[2.25rem]"
    >
      {{ commitPledge }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    TableTitle: {
      type: String,
    },
    titleCSSPropsStyle: {
      type: String,
    },
    overallDivClassCustom: {
      type: String,
    },
    fundType: {
      type: String,
      default: 'BF',
    },
    selectedYear: {
      type: Number,
      default: 2024,
    },
    commitPledge: {
      type: String,
    },
  },
  data() {
    return {
      overallDivClass: 'border-separate border-2 rounded-lg w-full flex flex-col',
      titleClass:
        'flex-1 font-bold rounded-t-lg py-[12px] md:py-[14px] lg:py-[16px] pl-[16px] md:pl-[20px] lg:pl-[24px] text-[1.125rem] md:text-[1.25rem] lg:text-[1.375rem] leading-[1.5rem] md:leading-[1.625rem] lg:leading-[1.75rem]',
      cellClass: 'flex-1 pl-[16px] py-[12px]',
    };
  },
};
</script>
